import { Card } from 'components/Card';
import { CardRow } from 'components/CardRow';
import { ICONS } from 'components/Icon';
import { SeparatorHorizontal } from 'components/SeparatorHorizontal';
import { useSelector } from 'hooks/useSelector';
import { theme } from 'lib/theme';
import React from 'react';
import { selectAseSetupLibraryQuestion } from 'store/remote/selectors';
import { AssessmentQuestionType } from 'types/types';

type Props = {
  id: number;
  selected: boolean;
  onPress: (id: number) => void;
  isLastQuestionOfSection: boolean;
  isLastQuestionOfFolder: boolean;
};

export const QuestionListItem: React.FC<Props> = React.memo(
  ({
    id,
    selected,
    onPress,
    isLastQuestionOfSection,
    isLastQuestionOfFolder,
  }) => {
    const question = useSelector((state) =>
      selectAseSetupLibraryQuestion(state, id),
    )!;

    return (
      <Card
        borderRadiusTop={false}
        borderRadiusBottom={isLastQuestionOfSection}
        margin={isLastQuestionOfFolder}
        separator={null}
      >
        <CardRow
          onPress={() => onPress(id)}
          checkedValue={selected}
          icon={
            question.type === AssessmentQuestionType.checklist
              ? ICONS.CircleCSolid
              : ICONS.CircleQSolid
          }
          iconColor={
            question.type === AssessmentQuestionType.checklist
              ? theme.colors.checklist
              : theme.colors.question
          }
          label={question.question}
          labelSize="small"
          labelNumberOfLines={0}
        />
        {!isLastQuestionOfFolder && !isLastQuestionOfSection && (
          <SeparatorHorizontal />
        )}
      </Card>
    );
  },
);
